const CATEGORY = {
    'ANNUAIRE': "annuaire",
    'BOUTIQUE': "boutique",
    'NORMAL': "catégorie",
    'GLOBAL': "annuaire global"
}

export default CATEGORY